import { FC, ReactNode } from "react"

import { Skeleton } from "@mui/material"
import { useSkeletonStatusProps } from "components/common/skeleton/skeleton.utils"

const TableSkeleton: FC<{ children?: ReactNode }> = ({ children }) => {
  const skeletonStatusProps = useSkeletonStatusProps()

  return (
    <Skeleton width="100%" height="340px" {...skeletonStatusProps}>
      {children}
    </Skeleton>
  )
}

export default TableSkeleton
